/* global WebAssembly */
import React from 'react';

export default class WebAssemblyProg extends React.Component {

    constructor(props) {
        super(props);

        //Web Assembly Initialization
        var memory = new WebAssembly.Memory({initial: 100});

        //Necessary library functions need to be binded to this instance
        var importObject = {
            system: {
                printInt: function (arg) {
                    this.writeHtml(arg);
                }.bind(this),
                printString: function (arg) {
                    var result = getString(arg, memory);
                    this.writeHtml(result);
                }.bind(this),
                readInt: function () {
                    var res = parseInt(prompt("Enter number(s):"), 10);
                    if (isNaN(res)) {
                        throw new Error("Could not parse int");
                    } else {
                        return res
                    }
                },

                // This function has a weird signature due to restrictions of the current WASM format:
                // It takes as argument the position that it needs to store the string to,
                // and returns the first position after the new string.
                readString0: function (memB) {
                    var s = prompt("Enter string(s):");
                    var size = s.length;
                    var padding = 4 - size % 4;
                    var fullString = s + " ".repeat(padding);
                    var newMemB = memB + size + padding;
                    var bufView8 = new Uint8Array(memory.buffer);
                    for (var i = 0; i < fullString.length; i++) {
                        bufView8[memB + i] = fullString.charCodeAt(i);
                    }
                    return newMemB;
                },
                popup: function(arg) {
                    var res = getString(arg, memory);
                    alert(res);
                },
                update: function(arg) {
                    var res = getString(arg, memory);
                    this.updateHtml(res);
                }.bind(this),
                button: function(arg) {
                    var res = getString(arg, memory);
                    this.writeHtml("<button type='button'>" + res + "</button>" );
                }.bind(this),
                mem: memory
            }
        };

        this.state = {wasmResult: "", importObject: importObject};

        this.run = this.run.bind(this);
        this.writeHtml = this.writeHtml.bind(this);
        this.updateHtml = this.updateHtml.bind(this);
        this.fetchAndInstantiate = this.fetchAndInstantiate.bind(this);
    }

    writeHtml(line) {
        if(this.props.writeM) {
            this.setState({wasmResult: this.state.wasmResult + line + "\n"});
        }
    }

    updateHtml(line) {
        if(this.props.writeM) {
            this.setState({wasmResult: line + "\n"});
        }
    }

    run(){

        var fileName = this.props.fileName;
        var t0, t1;

        //Keep context in promise
        var th = this;

        this.fetchAndInstantiate("./wasm/" + fileName + ".wasm", this.state.importObject).then(function(instance) {
            //Clean the slate first before running new program
            th.setState({wasmResult:""});

            t0 = performance.now();
            //Dynamically run the main of the web Assembly file without new component and code duplication
            instance["exports"][fileName + "_main"]();
            t1 = performance.now();

            var diff = (t1 - t0);

            if(th.props.perfM) {
                th.writeHtml("\nProgram took " + diff +
                    " ms.");
            }

            //Signal to parent that computation is over
            th.props.over(diff);
        });

    }

    render() {
        const {wasmResult} = this.state;

        return (
            <p className="Block-result">
            {this.props.writeM ? wasmResult : ">Writing is disabled"}
            </p>
        )
    }

    // This library function fetches the wasm module at 'url', instantiates it with
    // the given 'importObject', and returns the instantiated object instance
    // Taken from https://github.com/WebAssembly/spec
    fetchAndInstantiate(url, importObject) {
        return fetch(url).then(response =>
            response.arrayBuffer()
        ).then(bytes =>
            WebAssembly.instantiate(bytes, importObject)
        ).then(results =>
            results.instance
        );
    }
}

function getString(arg, memory) {
    var bufView = new Uint8Array(memory.buffer);
    var i = arg;
    var result = "";
    while(bufView[i] !== 0) {
        result += String.fromCharCode(bufView[i]);
        i = i + 1
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/WebAssemblyProg.js